import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { LinkContainer } from "react-router-bootstrap";
import { Auth } from "aws-amplify";
import { useHistory, useLocation } from "react-router-dom";
import Routes from "./Routes";
import { AppContext } from "./libs/contextLib";
import { onError } from "./libs/errorLib";
import admins from "./admins";
import "./App.css";

function App() {
  const search = useLocation().search;
  let mod = new URLSearchParams(search).get('m'); // Opration Type

  const history = useHistory();
  const [isAuthenticating, setIsAuthenticating] = useState(true); // true checking current authentication state
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [userProfile, setUserProfile] = useState({});
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    onLoad();
  }, []);
/*
  const isAdmin = () => {
    console.log('isAdmin...');
    console.log(userProfile);
    if (userProfile.attributes)
      return admins.includes(userProfile.attributes.preferred_username);
    return false;
  };
*/

  async function onLoad() {
    try {
      console.log('App onLoad...');
      await Auth.currentSession();
      const info = await Auth.currentUserInfo();
      userHasAuthenticated(true);
      console.log('Appp: current userinfo:');
      console.log(info);
      console.log(info.attributes.preferred_username);
      if (info.attributes && info.attributes.preferred_username)
        setIsAdmin(admins.includes(info.attributes.preferred_username));
      setUserProfile(info);
    }
    catch(e) {
      if (e !== 'No current user') {
        console.log('caught on App');
        onError(e);
      }
    }
    setIsAuthenticating(false);
  }

  async function handleLogout() {
    console.log('logout.....');
    await Auth.signOut();
    userHasAuthenticated(false);

    history.push('/');
  }

  return ( !isAuthenticating && (
    <div className="App container py-3">
      <header className="cf"><div className="sub_menu">
      <Navbar collapseOnSelect expand="md" className="mb-3">
        <LinkContainer to="/">
          <Navbar.Brand className="font-weight-bold text-muted">
            Scratch
          </Navbar.Brand>
        </LinkContainer>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          <Nav activeKey={window.location.pathname}>
          {isAuthenticated ? (
            <Nav.Link onClick={handleLogout}>ログアウト</Nav.Link>
            ) : (
              <>
                <LinkContainer className="hideMenuItem" to="/signup">
                  <Nav.Link>新規登録</Nav.Link>
                </LinkContainer>
                  <LinkContainer id="menuLogin" to={ mod == "am" ? "/login?m=am" : "/login" }>
                  <Nav.Link>ログイン</Nav.Link>
                </LinkContainer>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      </div>
      <div className="container cf site_title">
	  <h1><img src={process.env.PUBLIC_URL + '/images/common/logo.svg'} alt="日本臨床スポーツ医学会" /></h1>
      </div>
      </header>
      <AppContext.Provider value={{ isAuthenticated, userHasAuthenticated, userProfile, setUserProfile, isAdmin, setIsAdmin }}>
        <Routes />
      </AppContext.Provider>

      <footer>
        <div className="container">
        <small className="copy">© 日本臨床スポーツ医学会</small>
        </div>
      </footer>
    </div>
    )
  );
}

export default App;
